var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 80,
    viewBox: "0 0 90 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.5;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94,89H91.5v1H95V86.5H94Z",
    transform: "translate(-5 -25)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.9,
    height: 1,
    transform: "translate(77.6 64)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.9,
    height: 1,
    transform: "translate(68.7 64)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.9,
    height: 1,
    transform: "translate(59.8 64)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.9,
    height: 1,
    transform: "translate(50.9 64)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.9,
    height: 1,
    transform: "translate(42 64)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.9,
    height: 1,
    transform: "translate(33.1 64)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.9,
    height: 1,
    transform: "translate(24.2 64)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.9,
    height: 1,
    transform: "translate(15.4 64)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.9,
    height: 1,
    transform: "translate(6.5 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,86.5H5V90H8.5V89H6Z",
    transform: "translate(-5 -25)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(0 52.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(0 43.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(0 34)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(0 24.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(0 15.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(0 6.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,28.5H6V26H8.5V25H5Z",
    transform: "translate(-5 -25)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.9,
    height: 1,
    transform: "translate(77.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.6,
    height: 1,
    transform: "translate(70)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 1,
    transform: "translate(6.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,25v1H94v2.5h1V25Z",
    transform: "translate(-5 -25)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(89 52.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(89 43.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(89 34)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(89 24.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(89 15.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6.1,
    transform: "translate(89 6.6)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35,23.2a4.2,4.2,0,1,0-4.2,4.2A4.1,4.1,0,0,0,35,23.2Z",
    transform: "translate(-5 -10)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.8 28.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.4,62.4,78,57.1V57l2.8-1.5a1.149,1.149,0,0,0,.6-1.1,1.053,1.053,0,0,0-.8-1L65.9,49a1.083,1.083,0,0,0-1.2.5.908.908,0,0,0,0,1L71.8,64a1.1,1.1,0,0,0,1,.6,1.17,1.17,0,0,0,1.1-.8L75,60.2h.2l6.6,5.4a.985.985,0,0,0,1.5-.1l1.4-1.7A1.122,1.122,0,0,0,84.4,62.4Zm-.6.9L82.4,65s-.1.1-.1,0l-6.6-5.4a1.08,1.08,0,0,0-.7-.3.974.974,0,0,0-1,.8l-1,3.6a.1.1,0,0,1-.2,0L65.7,50.2v-.1l.1-.1,14.6,4.4a.1.1,0,0,1,.1.1c0,.1,0,.1-.1.1l-2.8,1.5a1.037,1.037,0,0,0-.6.8.951.951,0,0,0,.4,1l6.4,5.3Z",
    transform: "translate(-53.8 -38.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,45.3a.367.367,0,0,0,.3.1.758.758,0,0,0,.4-.2.494.494,0,0,0-.1-.7l-2.8-2.3a.494.494,0,0,0-.7.1.618.618,0,0,0,.2.7Z",
    transform: "translate(-53.8 -38.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,48.6c.2,0,.5-.2.5-.4a.548.548,0,0,0-.4-.6L54.4,47a.51.51,0,1,0-.2,1l3.7.6Z",
    transform: "translate(-53.8 -38.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,51.3A.446.446,0,0,0,58,51l-3.3,1.3a.446.446,0,0,0-.3.6.55.55,0,0,0,.5.3h.2l3.3-1.3C58.6,51.9,58.7,51.6,58.6,51.3Z",
    transform: "translate(-53.8 -38.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8,54l-2.3,2.8a.494.494,0,0,0,.1.7.367.367,0,0,0,.3.1.758.758,0,0,0,.4-.2l2.3-2.8a.494.494,0,0,0-.1-.7A.616.616,0,0,0,59.8,54Z",
    transform: "translate(-53.8 -38.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4,55.2a.548.548,0,0,0-.6.4l-.6,3.6a.548.548,0,0,0,.4.6h.1c.2,0,.5-.2.5-.4l.6-3.6C63.9,55.5,63.7,55.3,63.4,55.2Z",
    transform: "translate(-53.8 -38.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2,47a.55.55,0,0,0,.5.3h.2L74.3,46a.474.474,0,0,0-.3-.9l-3.4,1.3C70.2,46.4,70.1,46.7,70.2,47Z",
    transform: "translate(-53.8 -38.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7,44.5a.758.758,0,0,0,.4-.2l2.3-2.8a.5.5,0,1,0-.8-.6l-2.3,2.8a.494.494,0,0,0,.1.7C68.4,44.5,68.6,44.5,68.7,44.5Z",
    transform: "translate(-53.8 -38.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4,43.1h0a.675.675,0,0,0,.6-.4l.6-3.5a.51.51,0,1,0-1-.2L65,42.5A.548.548,0,0,0,65.4,43.1Z",
    transform: "translate(-53.8 -38.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5,42.8l-1.3-3.4a.474.474,0,1,0-.9.3l1.3,3.4a.55.55,0,0,0,.5.3h.2A.481.481,0,0,0,62.5,42.8Z",
    transform: "translate(-53.8 -38.6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,10V55H67l-.5-1H16V49.2l13.1-13,7.3,7.3.7.7.7-.7L57.9,23.4,74,39.5V51.6l1,.3V10ZM74,38,57.9,22,37.1,42.8l-8-8L16,47.8V11H74Z",
    transform: "translate(-15 -10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8,28.5a5.2,5.2,0,1,0-5.2-5.2A5.164,5.164,0,0,0,30.8,28.5Zm0-9.5a4.2,4.2,0,1,1-4.2,4.2A4.1,4.1,0,0,1,30.8,19Z",
    transform: "translate(-15 -10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropImage);
export default __webpack_public_path__ + "static/media/dropImage.97d2cb196e16b083affaf2ca82854bd5.svg";
export { ForwardRef as ReactComponent };